module.exports = __webpack_public_path__ + "media/src/images/arrow_left_disabled-52ee0630ef76d103af6fdc49466e817e.png";